// src/utils/stakeholderCategories.js
// Single source of truth for stakeholder categories.

export const CATEGORY_UNSORTED_ID = "unsorted";

export const BUILTIN_CATEGORY_IDS = [
  "client",
  "partner",
  "provider",
  "technical",
  "business",
  "subsidiary",
];

export const BUILTIN_CATEGORY_NAMES_FR = {
  client: "Client",
  partner: "Partenaire",
  provider: "Prestataire",
  technical: "Service technique",
  business: "Service métier",
  subsidiary: "Filiale",
  unsorted: "Non classé",
};

export const BUILTIN_CATEGORY_NAMES_EN = {
  client: "Client",
  partner: "Partner",
  provider: "Provider",
  technical: "Technical service",
  business: "Business service",
  subsidiary: "Subsidiary",
  unsorted: "Unsorted",
};

// Deterministic palette for custom categories (no color picker UX needed).
const CATEGORY_PALETTE = [
  "#3B82F6",
  "#10B981",
  "#F59E0B",
  "#8B5CF6",
  "#EC4899",
  "#6366F1",
  "#EF4444",
  "#14B8A6",
  "#F97316",
  "#0EA5E9",
];

const hashId = (id) => {
  let h = 0;
  const s = String(id);
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

export const getCategoryColor = (id) =>
  CATEGORY_PALETTE[hashId(id) % CATEGORY_PALETTE.length];

export const isBuiltinCategory = (id) => BUILTIN_CATEGORY_IDS.includes(id);

export const getBuiltinLabel = (id, language) => {
  const lang = language === "en" ? BUILTIN_CATEGORY_NAMES_EN : BUILTIN_CATEGORY_NAMES_FR;
  return lang[id] || String(id);
};

// Ensure the 6 built-in category entries exist in a stored stakeholder list.
// Pristine built-ins have NO name: i18n labels are used until the user renames them.
export const ensureBuiltinStakeholderCategories = (stakeholders = [], language) => {
  const list = Array.isArray(stakeholders) ? stakeholders : [];
  const missing = BUILTIN_CATEGORY_IDS.filter(
    (id) => !list.some((s) => s.isCategory && s.id === id),
  );
  if (missing.length === 0) return list;
  const now = new Date().toISOString();
  const builtins = missing.map((id) => ({
    id,
    name: undefined,
    isCategory: true,
    builtin: true,
    createdAt: now,
    updatedAt: now,
  }));
  return [...list, ...builtins];
};

// Display name: custom/renamed name wins, else i18n for built-ins, else raw id.
export const getCategoryDisplayName = (cat, t, language) => {
  if (!cat) return "";
  if (cat.name) return cat.name;
  if (isBuiltinCategory(cat.id) && t) {
    return t(`workshop3.activity1.categories.${cat.id}`, {
      defaultValue: getBuiltinLabel(cat.id, language),
    });
  }
  return getBuiltinLabel(cat.id, language) || String(cat.id);
};